export default __webpack_public_path__ + "static/media/lesson-plan-bg.3f337ac5.svg";